var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgMove = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -8)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m8.0275933 9.5013891c-2.8183472.0466368-5.2878242 1.2552559-6.2839838 4.1947259-.98846785 2.916771 1.1714865 8.182008 5.9325763 5.840503 7.9077412-3.889027 7.9038032.963382 9.8807382.963382 2.438571 0 4.94037-1.699566 4.94037-3.873599 0-1.944514.09638-3.806388-.992208-4.87712-1.976935-1.944514-2.973677.987396-8.289071-1.184158-1.694017-.6920746-3.4974127-1.0917169-5.1884217-1.0637339z",
    fill: "#8cbe8c",
    fillRule: "evenodd",
    stroke: "#555753",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-27.5 6.000001)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#3c5a6e",
    height: 11,
    rx: 2.01149,
    width: 11,
    x: 40.5,
    y: 14.999999
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m41.500001 20.999999 8.999999-.009599s0 0 0-2c0-2.990401-1-2.990401-4.5-2.990401s-4.5 0-4.5 3c0 2 0 2 .000001 2z",
    fill: "#fcffff",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "m45.5 15.999999v3.000001h-4v3h4v2.999999l5-4z",
    fill: "#fff"
  }))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMove, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/move.e0d3656d.svg";
export { ForwardRef as ReactComponent };